import { useTranslation } from 'next-i18next'
import ShipsFrozenIcon from '@components/icons/pdp/shipsfrozen'
import ProhibitionIcon from '@components/icons/pdp/prohibition-icon'
import Image from '@components/ui/image'

export default function ShipsFrozenNoReturn({ data }: any) {
  const { t: translate } = useTranslation(['common', 'pdp'])
  const isReturnable = data?.mag_attributes?.find(
    (attr: { attribute_code: string }) =>
      attr.attribute_code === 'is_returnable',
  )?.value

  // If no temperature description or returnability info, return null
  if (!data?.temperature_description || !isReturnable) {
    return null
  }

  // Render component only if either condition is met
  const shouldShowFrozen =
    data.temperature_description === 'Frozen' ||
    data.temperature_description === 'Refrigerated'
  const shouldShowNoReturn = isReturnable === '0'

  if (!shouldShowFrozen && !shouldShowNoReturn) {
    return null
  }

  return (
    <div className="border p-4 py-7">
      {shouldShowFrozen && (
        <div className="flex  relative">
          <Image src="/icons/ships-frozen.png" width={40} height={40} />
          <p className="text-brand-dark font-semibold ml-3 mt-2 text-[16px] ">
            <a className="underline cursor-pointer text-brand group">
              {translate('text-ships', { ns: 'pdp' })}{' '}
              {data?.temperature_description}
              <div className="absolute left-0 sm:-left-10 z-10 hidden w-[200px] sm:w-[280px] -top-[120px]  sm:-top-[110px] group-hover:block">
                <div className="rounded-md border-2 border-gray-300 bg-white  p-3 sm:p-4 text-center leading-1 text-sm  font-semibold text-brand-dark  relative">
                  {data?.temperature_description === 'Frozen'
                    ? translate('text-frozen-tooltip', { ns: 'pdp' })
                    : translate('text-refrigerated-tooltip', { ns: 'pdp' })}
                  <div className="absolute left-1/2 top-full -ml-2 w-4 h-4 overflow-hidden">
                    <div className="absolute left-0 bottom-3 w-4 h-4 b-4  rotate-45  bg-white  border-b-2 border-r-2 border-gray-300 "></div>
                  </div>
                </div>
              </div>
            </a>{' '}
            {translate('text-in-proprietary-boxes', { ns: 'pdp' })}
          </p>
        </div>
      )}

      {shouldShowNoReturn && (
        <div className="flex mt-3">
          <ProhibitionIcon />
          <p className="text-brand-dark font-semibold leading-4 ml-3 mt-1 text-[16px]">
            {translate('text-no-return', { ns: 'common' })}
            <p className="text-brand-gray font-medium text-xs leading-3 mt-2 text-[12px]">
              {translate('text-no-return-description', { ns: 'common' })}
            </p>
          </p>
        </div>
      )}
    </div>
  )
}
